import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bell, Calendar, MessageCircle, DollarSign, Star, CheckCircle2, XCircle, Clock } from 'lucide-react';
export function ProviderDashboardScreen() {
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(true);
  const pendingBookings = [{
    id: 1,
    patient: 'John Doe',
    type: 'Video Consult',
    time: 'Today, 2:00 PM',
    fee: '₦15,000'
  }, {
    id: 2,
    patient: 'Sarah Smith',
    type: 'Home Visit',
    time: 'Tomorrow, 10:00 AM',
    fee: '₦25,000'
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="flex flex-col min-h-screen bg-slate-50 pb-20" data-id="element-1337">
      <div className="bg-blue-600 px-6 pt-12 pb-6 text-white sticky top-0 z-10 rounded-b-3xl shadow-md" data-id="element-1338">
        <div className="flex items-center justify-between mb-6" data-id="element-1339">
          <div data-id="element-1340">
            <p className="text-blue-200 text-sm" data-id="element-1341">Provider Dashboard</p>
            <h1 className="text-xl font-bold" data-id="element-1342">Dr. Chinedu Okafor</h1>
          </div>
          <button className="p-2 bg-white/10 rounded-full relative" data-id="element-1343">
            <Bell className="w-5 h-5 text-white" data-id="element-1344" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border border-blue-600" data-id="element-1345"></span>
          </button>
        </div>

        <div className="bg-white/10 rounded-xl p-4 flex items-center justify-between backdrop-blur-sm border border-white/20" data-id="element-1346">
          <div className="flex items-center gap-3" data-id="element-1347">
            <div className={`w-3 h-3 rounded-full ${isOnline ? 'bg-green-400' : 'bg-slate-400'}`} data-id="element-1348" />
            <span className="font-medium" data-id="element-1349">
              {isOnline ? 'Online & Accepting' : 'Offline'}
            </span>
          </div>
          <button onClick={() => setIsOnline(!isOnline)} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${isOnline ? 'bg-white text-blue-600' : 'bg-slate-700 text-white'}`} data-id="element-1350">
            {isOnline ? 'Go Offline' : 'Go Online'}
          </button>
        </div>
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-1351">
        <div className="grid grid-cols-3 gap-3 mb-8" data-id="element-1352">
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center" data-id="element-1353">
            <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center mb-2" data-id="element-1354">
              <Calendar className="w-5 h-5 text-blue-600" data-id="element-1355" />
            </div>
            <span className="text-2xl font-bold text-slate-900" data-id="element-1356">4</span>
            <span className="text-xs text-slate-500 font-medium" data-id="element-1357">Today</span>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center" data-id="element-1358">
            <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center mb-2" data-id="element-1359">
              <DollarSign className="w-5 h-5 text-green-600" data-id="element-1360" />
            </div>
            <span className="text-xl font-bold text-slate-900" data-id="element-1361">₦45k</span>
            <span className="text-xs text-slate-500 font-medium" data-id="element-1362">Earned</span>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-slate-100 flex flex-col items-center text-center" data-id="element-1363">
            <div className="w-10 h-10 bg-purple-50 rounded-full flex items-center justify-center mb-2" data-id="element-1364">
              <MessageCircle className="w-5 h-5 text-purple-600" data-id="element-1365" />
            </div>
            <span className="text-2xl font-bold text-slate-900" data-id="element-1366">2</span>
            <span className="text-xs text-slate-500 font-medium" data-id="element-1367">Messages</span>
          </div>
        </div>

        <div className="mb-8" data-id="element-1368">
          <div className="flex items-center justify-between mb-4" data-id="element-1369">
            <h3 className="font-semibold text-slate-900" data-id="element-1370">Pending Requests</h3>
            <span className="bg-amber-100 text-amber-700 text-xs font-bold px-2 py-1 rounded-full" data-id="element-1371">
              2 New
            </span>
          </div>

          <div className="space-y-4" data-id="element-1372">
            {pendingBookings.map(booking => <div key={booking.id} className="bg-white p-4 rounded-2xl shadow-sm border border-slate-100" data-id="element-1373">
                <div className="flex justify-between items-start mb-3" data-id="element-1374">
                  <div data-id="element-1375">
                    <h4 className="font-bold text-slate-900" data-id="element-1376">
                      {booking.patient}
                    </h4>
                    <p className="text-sm text-slate-500 flex items-center gap-1 mt-1" data-id="element-1377">
                      <Clock className="w-3 h-3" data-id="element-1378" /> {booking.time}
                    </p>
                  </div>
                  <div className="text-right" data-id="element-1379">
                    <span className="text-xs font-bold uppercase tracking-wider bg-blue-50 text-blue-700 px-2 py-1 rounded-md block mb-1" data-id="element-1380">
                      {booking.type}
                    </span>
                    <span className="font-semibold text-slate-900" data-id="element-1381">
                      {booking.fee}
                    </span>
                  </div>
                </div>
                <div className="flex gap-2 pt-3 border-t border-slate-100" data-id="element-1382">
                  <button className="flex-1 bg-slate-100 text-slate-700 py-2 rounded-xl font-medium text-sm flex items-center justify-center gap-1 hover:bg-slate-200" data-id="element-1383">
                    <XCircle className="w-4 h-4" data-id="element-1384" /> Decline
                  </button>
                  <button className="flex-1 bg-blue-600 text-white py-2 rounded-xl font-medium text-sm flex items-center justify-center gap-1 hover:bg-blue-700" data-id="element-1385">
                    <CheckCircle2 className="w-4 h-4" data-id="element-1386" /> Accept
                  </button>
                </div>
              </div>)}
          </div>
        </div>

        <div data-id="element-1387">
          <h3 className="font-semibold text-slate-900 mb-4" data-id="element-1388">Recent Reviews</h3>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-slate-100" data-id="element-1389">
            <div className="flex items-center gap-2 mb-2" data-id="element-1390">
              <div className="flex text-amber-400" data-id="element-1391">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-1392" />)}
              </div>
              <span className="text-sm font-medium text-slate-900" data-id="element-1393">5.0</span>
            </div>
            <p className="text-sm text-slate-600 italic" data-id="element-1394">
              "Dr. Chinedu was very professional and explained everything
              clearly. Highly recommend!"
            </p>
            <p className="text-xs text-slate-400 mt-2" data-id="element-1395">- Anonymous Patient</p>
          </div>
        </div>
      </div>
    </motion.div>;
}